import { pickBy } from 'lodash';
import { CSSProperties } from 'react';
import { css } from 'styled-components';
import {
  defaultRenderFileType,
  pngLeftPadding,
  pngScaleFactor,
  renderViewDefaultHorizontalMargin,
  renderViewDefaultTopMargin,
  shareImageHorizontalMargin,
} from '../../../../common/renderer/renderer-settings';
import { RenderFileType, RenderOptions } from '../../../../common/renderer/types';

export function getScreenshotAreaStyle(options: Partial<RenderOptions>): string {
  if (options.isShareImg) {
    // ShareImage is the dynamic image we generate when people share a net impact
    // profile in the webz, like FB, Twitter, Slack etz.
    const shareImageStyle: string = css`
      margin-top: 100px;
      margin-left: ${shareImageHorizontalMargin};
      margin-right: ${shareImageHorizontalMargin};
    `.join('');
    return shareImageStyle;
  }

  // OA: Style objects are used here to be able to overwrite stuff in order to prevent
  // duplicate keys ending up in final CSS. Yes, it's a bit confusing, and probably unnecessary.
  const baseStyle: CSSProperties = {
    marginTop: options.topMargin !== undefined ? options.topMargin : renderViewDefaultTopMargin,
    position: options.showControlUi ? undefined : 'absolute',
    left: options.showControlUi ? undefined : renderViewDefaultHorizontalMargin,
    marginLeft: options.showControlUi ? renderViewDefaultHorizontalMargin : undefined,
    width: options.width,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  };

  const pngStyle: CSSProperties = getPngStyle(options);

  const styleString = css`
    ${toCSSstring({ ...baseStyle, ...pngStyle })}
    & > * + * {
      margin-top: 60px;
    }
  `.join('');

  return styleString;
}

function getPngStyle(options: Partial<RenderOptions>) {
  const renderFileType = options.renderFileType || defaultRenderFileType;
  if (renderFileType !== RenderFileType.PNG || options.showControlUi) {
    return {};
  }
  const style: CSSProperties = {
    left: pngLeftPadding * pngScaleFactor,
    transform: `scale(${pngScaleFactor})`,
    transformOrigin: 'top left',
  };
  return style;
}

function toCSSstring(style: CSSProperties): string {
  const styleWithValues = pickBy(style, value => value !== undefined);
  const styleString = `${Object.entries(styleWithValues)
    .map(
      ([key, value]) =>
        `${key.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`)}:${
          typeof value === 'number' ? `${value}px` : value
        }`,
    )
    .join(';')};`;
  return styleString;
}
